import AjaxLoad from '../../utilities/js/ajax-load';
import SlimSelect from 'slim-select';

class FormFields {
    constructor (el, options) {
        const defaults = {
            wrapperClass: '.form__element',
            fieldClass: '.form__input',
            fieldFilledClassname: 'form__input--filled',
            errorClassname: 'form__element--error',
            onLoaded: null
        };

        this.$formfield = el;
        this.selectField = '';
        this.settings = Object.assign({}, defaults, options);
        this.states = [];
        this.selectedValue = '';
    }

    initialize () {
        const formfieldTagname = this.$formfield.tagName.toLowerCase();
        this.setFilled(this.$formfield);
        this.setEvents();
        this.intiSelectField(formfieldTagname);
    }

    checkForUploader ($field) {
        const $form = $field.closest('form');

        if ($form) {
            const $uploader = $form.querySelector('[data-uploader]');
            if ($uploader) {
                import('../../components/upload/upload').then(({ Uploader }) => {
                    let uploader = new Uploader($uploader); // eslint-disable-line
                });
            }
        }
    }

    setEvents () {
        ['change', 'keyup', 'focus'].forEach(e => {
            this.$formfield.addEventListener(e, () => {
                if (this.$formfield.closest(this.settings.wrapperClass)?.classList.contains(this.settings.errorClassname)) {
                    this.$formfield.closest(this.settings.wrapperClass)?.classList.remove(this.settings.errorClassname);
                }

                this.setFilled(this.$formfield);
            });
        });
    }

    intiSelectField (formfieldTagname) {
        switch (formfieldTagname) {
        case 'select':
            if (this.$formfield.hasAttribute('no-uniform') === false && this.$formfield.hasAttribute('data-studioselector') === false) {
                this.selectField = new SlimSelect({
                    select: this.$formfield,
                    settings: {
                        showSearch: false
                    }
                });
            }

            // // check for language switcher
            if (this.$formfield.getAttribute('data-select') === 'language-switch') {
                this.selectField = new SlimSelect({
                    select: this.$formfield,
                    settings: {
                        showSearch: false
                    },
                    data: this.getLanguageTemplate(this.$formfield),
                    events: {
                        afterChange: (newVal) => {
                            this.selectedValue = newVal;
                            this.onLangaugeChange();
                        }
                    }
                });
                this.selectedValue = this.selectField.getSelected();
            }

            if (this.$formfield.hasAttribute('data-studioselector')) {
                this.selectField = new SlimSelect({
                    select: this.$formfield,
                    settings: {
                        showSearch: false
                    },
                    events: {
                        afterChange: (newVal) => {
                            window.location.href = newVal[0].value;
                        }
                    }
                });
            }

            break;

        case 'textarea':

            break;

        default:

            // eslint-disable-next-line no-case-declarations
            const formfieldType = this.$formfield.getAttribute('type');

            switch (formfieldType) {
            case 'checkbox':
                break;

            case 'radio':
                break;

            case 'file':
                this.checkForUploader(this.$formfield);
                break;

            default:
                break;
            }

            break;
        }
    }

    checkFilled ($field) {
        const fieldValue = $field.value;
        let filled;

        switch (true) {
        case (fieldValue === ''):
            filled = false;
            break;

        case (fieldValue === '-1'):
            filled = false;
            break;

        case (typeof fieldValue === 'object' && fieldValue !== null):

            if (fieldValue.length === 0) {
                filled = false;
            } else if (fieldValue.indexOf('-1') === -1) {
                filled = true;
            } else {
                fieldValue.value = [];
                filled = false;
            }

            break;

        default:
            filled = true;
            break;
        }

        return filled;
    }

    setFilled ($field) {
        const filled = this.checkFilled($field);

        if (filled === true) {
            $field.closest(this.settings.fieldClass)?.classList.add(this.settings.fieldFilledClassname);
        } else {
            $field.closest(this.settings.fieldClass)?.classList.remove(this.settings.fieldFilledClassname);
        }
    }

    onLangaugeChange () {
        const $form = this.$formfield.closest('form');
        const $sidebarContent = $form.closest('[data-sidebar-content]');
        const action = $form.getAttribute('action');
        const formData = new FormData($form);
        // eslint-disable-next-line no-new
        new AjaxLoad(action, {
            requestMethod: 'POST',
            requestData: formData,
            onSuccess: (result) => {
                // remove error classes from markup string
                // eslint-disable-next-line prefer-regex-literals
                const noErrorMarkup = result.replace(new RegExp('form__element--error', 'g'), '');
                // change markup
                if ($sidebarContent) {
                    $sidebarContent.innerHTML = noErrorMarkup;

                    if (typeof this.settings.onLoaded === 'function') {
                        this.settings.onLoaded($sidebarContent);
                    }
                }
            }
        });
    }

    getLanguageTemplate (select) {
        const baseUrl = 'assets/images/flags';
        for (let i = 0; i < select.options.length; i++) {
            const option = select.options[i];
            const optionValue = option.value;
            const optionText = option.textContent;
            const $state = {
                value: optionValue,
                text: optionText,
                html: `<span><img src="/${baseUrl}/${optionValue}.svg" class="language-switch__flag" />${optionText}</span>`,
                selected: select.value === option.value
            };
            this.states.push($state);
        }

        return this.states;
    }
}

export { FormFields };
